module.exports = __webpack_public_path__ + "img/wrestling.ab8285cc.svg";